import React from 'react';
const WarningFilledIcon = ({ size = 16, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM7 6.3C7.3866 6.3 7.7 6.6134 7.7 7V10.5006C7.7 10.8872 7.3866 11.2006 7 11.2006C6.6134 11.2006 6.3 10.8872 6.3 10.5006V7C6.3 6.6134 6.6134 6.3 7 6.3ZM7 4.9C7.3866 4.9 7.7 4.5866 7.7 4.2C7.7 3.8134 7.3866 3.5 7 3.5C6.6134 3.5 6.3 3.8134 6.3 4.2C6.3 4.5866 6.6134 4.9 7 4.9Z" fill={color || "#8F0000"} />
        </svg>


    )
};

export default WarningFilledIcon;
